import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';

import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import ReportDetailKu from './ReportDetailKu';

class DetailKu extends Component{
    constructor(props) {
        super(props);
        this.state = { 
            isLoading : false,
            error: false,
            errorCode: null,
            resMessage: null,
            alertShow: false,
            kodeJenjangSekolah : null,
            ta: [],
            kelas: [],
            kelasParalel: [],
            jadwalCbt: [],
            placementIpa: [],
            placementIps: [],
            placementBhs: [],
            kodeTahunAjaran: null,
            idKelas: null,
            idJadwal: null
        }
    }

    componentDidMount(){
        console.clear();
        console.log('IKI PROPS')
        console.log(this.props)
        if(!__.isEmpty(this.props.data.ta)){
            this.setState({ 
                ta : this.props.data.ta,
                kelas : this.props.data.kelas,
                kodeTahunAjaran : this.props.data.kodeTa,
                // idKelas : this.props.data.kuota.idKelas,
                jadwalCbt : this.props.data.jadwalCbt
            });
        }
    }

    handleOnChange = async (e) =>{
        let name = e.target.name;
        let val = e.target.value;
        this.setState({ [name]:val });


        // cari profil PEMINATAN
        if(name === 'idKelas'){
            this.setState({isLoading: true, kelasParalel:[], idKelasParalel:'', jadwalCbt:[], idJadwal:''});
            const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, 
                {KelasParalelSearch,['idKelas']: val, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
            })  
    
            // masukan kelas paralel ke  dropdown
            if(resKelasParalel){
                if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        kelasParalel: resKelasParalel.data.data
                    })
                }
            }
            this.setState({isLoading: false});
        }

        if(name === 'idKelasParalel'){
            this.setState({isLoading: true, jadwalCbt:[], idJadwal:''});
            const response = await accountManagement.get(CONFIG.REPORT_CBT_GET_JADWAL, {
                params: { 
                    tahunAjaran: this.state.kodeTahunAjaran, 
                    idSekolah: this.props.account.idSekolah,
                    idKelas: this.state.idKelas,
                    tipeCbt: 'PEMINATAN'
                }
            }).catch (function(error){ console.log(error)}) 
    
            if(response) {
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        idJadwal:'',
                        jadwalCbt: response.data.data 
                    })
                }
            }
            this.setState({isLoading: false});
        }

        /* if(name === 'idJadwal'){
            this.setState({isLoading: true, listSiswa:[]});
            const response = await accountManagement.get(CONFIG.REPORT_CBT_LIST_SISWA, {
                params: { 
                    tahunAjaran: this.state.kodeTahunAjaran, 
                    idJadwalCbt: val,
                    idKelasParalel: this.state.idKelasParalel
                }
            }).catch (function(error){ console.log(error)}) 
    
            if(response) {
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listSiswa: response.data.data
                    })
                }
            }
            this.setState({isLoading: false});
        } */
    }

    tutupReportDetail = async ()=> {
        this.setState({
            placementIpa: [],
            placementIps: [],
            placementBhs: []
        })
    }

    async fetchDetailKecakapanUmum(){
        
    }

    handleSubmit = async (e)=>{
        this.setState({ isFetching: true });
        e.preventDefault();
        console.log(this.state); 
        
        const response = await accountManagement.get(CONFIG.PEMINATAN_DETAIL_KECAKAPAN_UMUM+this.state.idJadwal
                                                    ).catch(function(error){})
                                                    
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    isFetching: false,
                    alertShow: false,
                    namaSekolah: response.data.data.namaSekolah,
                    placementIpa: response.data.data.placementIpa,
                    placementIps: response.data.data.placementIps,
                    placementBhs: response.data.data.placementBhs,
                });
            }else{
                this.setState({ 
                    alertShow: true,
                    isFetching: false,
                    error : true,
                    errorCode : response.data.errorSchema.errorCode,
                    resMessage : response.data.errorSchema.errorMessage 
                });
            }
        }else{
            this.setState({ 
                alertShow: true,
                isFetching: false,
                error : true,
                errorCode : response.data.errorSchema.errorCode,
                resMessage : response.data.errorSchema.errorMessage 
            });
        }
    }

    render() { 
        const {jurusan, kodeJenjangSekolah, isReport, isReportSiswa, jadwalCbt, placementIpa, placementIps, placementBhs, error} = this.state;
        return (
            <>
            { __.isEmpty(placementIpa) && __.isEmpty(placementIps) && __.isEmpty(placementBhs) ?
            // {!error ?
                <div className="wrapper">
                    <Sidebar account={this.props.account}/>
                    <LoaderModal isFetching={this.state.isFetching} />
                    <div id="content" style={{paddingBottom: '50px'}}>
                        <Navbar title="Detail Kecakapan Umum Siswa"/>
                        {this.loadAlert()}
                        <form onSubmit={this.handleSubmit}>
                            <Row>  
                                <Col sm={6}>   
                                    <Col style={{marginTop:'10px'}}><select className="form-control" name="kodeTahunAjaran" value={this.state.kodeTahunAjaran} onChange={this.handleOnChange} required>
                                            <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                            <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                        </select>
                                    </Col> 
                                    <Col style={{marginTop:'10px'}}><select className="form-control" name="idKelas" value={this.state.idKelas} onChange={this.handleOnChange} required>
                                            <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                            <DropdownKelas kelas={this.state.kelas} />
                                        </select>
                                    </Col>
                                </Col>
                                <Col sm={6}>
                                    <Col style={{marginTop:'10px'}}><select className="form-control" name="idKelasParalel" value={this.state.idKelasParalel} onChange={this.handleOnChange} required>
                                            <option value="" selected disabled>~~ Pilih Kelas Paralel~~</option>
                                            <DropdownKelasParalel kelasParalel={this.state.kelasParalel} />
                                        </select>
                                    </Col>
                                    <Col style={{marginTop:'10px'}}><select className="form-control" name="idJadwal" value={this.state.idJadwal} onChange={this.handleOnChange} required>
                                        <option value="" selected disabled>~~ Pilih CBT ~~</option>
                                        {jadwalCbt.map(jadwal => 
                                            <option value={jadwal.idJadwalCbt}>{jadwal.namaJadwalCbt}</option>
                                        )}
                                        </select>
                                    </Col> 
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{margin :'18px', textAlign: 'right'}}><i>NB. Pastikan anda sudah pernah me-Generate <a href="javascript:void()" onClick={() => this.props.tutupReport()} style={{color :'red'}}><b>"Report Peminatan"</b></a> </i></Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <button type="submit" className="btn btn-outline-primary pull-right" title="Kembali" style={{marginRight:'1em', marginTop:'5px'}} >
                                        Lihat Report 
                                    </button>
                                </Col>
                            </Row>
                        </form>
                        <Row>
                            <Col>{this.loading()}</Col>
                        </Row>
                        <br />
                        <div id="btn_print">                        
                            <div className="fixed_button">
                                <button className="btn btn-outline-danger pull-left" title="Kembali" style={{marginLeft:'1em'}} onClick={() => this.props.tutupReport() }>
                                    <li className="fa fa-arrow-left"></li>
                                </button>
                            </div>     
                        </div>
                    </div>
                </div>
                :
                <ReportDetailKu tutupReportDetail={this.tutupReportDetail} params={this.state}/> 
            }
            </>
        );
    }

    loading = () =>{
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }
    
    loadAlert = () => {
        const {alertShow, errorCode,  resMessage} = this.state;
      
        if (alertShow) {
            if(errorCode === CONFIG.INTERNAL_SERVER_ERROR_CODE)
                return (
                    <Alert variant="warning" onClose={() => this.setState({ alertShow: false })} dismissible>
                        <strong>{resMessage}</strong>
                    </Alert>
                );
                else if(errorCode === CONFIG.ERROR_CODE_ENTITY_NOT_FOUND)
                    return (
                        <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                            <strong>{resMessage}</strong>
                        </Alert>
                    );
                else if(errorCode === CONFIG.SUCCESS_ERROR_CODE)
                    return (
                        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                            <strong>{resMessage}</strong>
                        </Alert>
                    );
        } 
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(DetailKu);